import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { brand } from '../theme';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 640,
    marginBottom: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(7),
    },
  },
  eyebrow: {
    display: 'flex',
    alignItems: 'center',
    color: brand.accent,
    marginBottom: theme.spacing(2),
  },
  index: {
    marginRight: 12,
    paddingRight: 12,
    borderRight: `1px solid currentColor`,
    lineHeight: 1,
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  light: {
    color: '#FFFFFF',
    '& $subtitle': {
      color: 'rgba(255,255,255,0.7)',
    },
    '& $eyebrow': {
      color: '#E2A58F',
    },
  },
}));

export default function SectionHeading({ index, eyebrow, title, subtitle, light = false, className = '' }) {
  const classes = useStyles();

  return (
    <Box className={`${classes.root} ${light ? classes.light : ''} ${className}`}>
      {eyebrow && (
        <Typography variant="overline" component="p" className={classes.eyebrow}>
          {index && <span className={classes.index}>{index}</span>}
          {eyebrow}
        </Typography>
      )}
      {title && (
        <Typography variant="h2" component="h2" className={classes.title}>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography variant="subtitle1" className={classes.subtitle}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
